// extracted by mini-css-extract-plugin
export var card = "_la-5";
export var cardSelected = "_la-4";
export var image = "_la-3";
export var modal = "_la-0";
export var modalContent = "_la-1";
export var table = "_la-2";